// extracted by mini-css-extract-plugin
module.exports = {"dialogOverlay":"Dialog_dialogOverlay___CoGZ","dialogContent":"Dialog_dialogContent__mHcbc","closeButton":"Dialog_closeButton__ABO2H"};